export default class PopUp extends Phaser.GameObjects.Container {
    constructor(scene, x, y) {
        super(scene, x, y, []);
        this.scene = scene;
        scene.add.existing(this);

        this.soundManager = scene.soundManager

    }

    animIn(endFunc = null){
        // TODO : ajouter audio 
        // this.scene.soundManager.playOnce('')
        this.y +=50
        this.setAlpha(0)
        this.scene.tweens.add({
            targets: this,
            alpha: 1,
            y: this.y - 50,
            duration: 200,
            onComplete: () => {                
                if(endFunc)
                    endFunc()
            }   
        });
    }

    animOut(endFunc = null){
        this.scene.tweens.add({
            targets: this,
            alpha: 0,
            y: this.y + 50,
            duration: 200,
            onComplete: () => {
                if(endFunc)
                    endFunc()
            }
        });
    }
}